import React, { lazy, useContext, useMemo } from 'react';
import SectionHeader from '@nile/reports/src/modules/EfficiencyReport/components/subpages/SectionHeader';
import SectionMeta from '@nile/reports/src/modules/EfficiencyReport/components/subpages/SectionMeta';
import SectionData from '@nile/reports/src/modules/EfficiencyReport/components/subpages/SectionData';
import ReportsContext from '@nile/reports/src/modules/home/contexts/Reports';
import { isEmpty } from 'lodash';

const SectionAdditionalData = lazy(() =>
  import(
    '@nile/reports/src/modules/EfficiencyReport/components/subpages/SectionAdditionalData'
  )
);

function EfficiencyReportSheet(props) {
  const { client = null, setClient } = props;
  const reportsContext = useContext(ReportsContext);

  const chartData = props?.layout?.filter((el) => el.hasOwnProperty('chart'));

  const advancedChartData = props?.layout?.filter((el) =>
    el.hasOwnProperty('advancedChart')
  );
  const advancedMetaChartData = props?.layout?.filter((el) =>
    el.hasOwnProperty('advancedMetaChart')
  );

  const condition = useMemo(() => {
    return reportsContext?.reportCondition?.[reportsContext?.activeView];
  }, [reportsContext?.reportCondition?.[reportsContext?.activeView]]);

  return (
    <>
      <SectionHeader
        {...props}
        action={
          {
            ...props?.filter,
            value: client,
            setValue: setClient,
            isClient: true
          } || null
        }
        condition={condition}
      />
      {props?.section !== 'CLIENT_WISE_EFFICIENCY' && (
        <>
          {!isEmpty(chartData) && (
            <SectionMeta layoutData={chartData} condition={condition} />
          )}
          {!isEmpty(advancedChartData) && (
            <SectionData
              layoutData={advancedChartData}
              {...props}
              condition={condition}
              setClient={setClient}
            />
          )}
          {!isEmpty(advancedMetaChartData) && (
            <SectionAdditionalData
              layoutData={advancedMetaChartData}
              {...props}
              condition={condition}
            />
          )}
        </>
      )}
      {props?.section === 'CLIENT_WISE_EFFICIENCY' && !isEmpty(client) && (
        <>
          {!isEmpty(chartData) && (
            <SectionMeta layoutData={chartData} condition={condition} />
          )}
          {!isEmpty(advancedChartData) && (
            <SectionData
              layoutData={advancedChartData}
              {...props}
              condition={condition}
              client={client}
            />
          )}
          {!isEmpty(advancedMetaChartData) && (
            <SectionAdditionalData
              layoutData={advancedMetaChartData}
              {...props}
              condition={condition}
            />
          )}
        </>
      )}
    </>
  );
}

export default EfficiencyReportSheet;
